import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { BreadcrumbComponent } from '@components/breadcrumb/breadcrumb.component';
import { TabViewModule } from 'primeng/tabview';
import { ConsultarNssComponent } from './consultar/consultar.component';
import { UploadNssComponent } from './upload/upload.component';
import { TagModule } from 'primeng/tag';
import { ShowForRolesDirective } from '@directives/show-for-roles.directive';

@Component({
  selector: 'app-consultar-nss',
  imports: [CommonModule, BackboneComponent, BreadcrumbComponent, TagModule, TabViewModule, ShowForRolesDirective, ConsultarNssComponent, UploadNssComponent],
  templateUrl: './consultar-nss.component.html',
  styleUrl: './consultar-nss.component.scss',
})
export class ConsultarNssPage {}
